<div class="screen">
  <div class="screen-container">
    <div class="screen-header">
      Generating Rail Table
    </div>
    <div class="screen-body">
      <!-- Floating error message -->
      <div *ngIf="errorMessage" class="floating-error" [ngClass]="getErrorType()">
        <i class="fa" [ngClass]="{
          'fa-exclamation-circle': getErrorType() === 'error',
          'fa-exclamation-triangle': getErrorType() === 'warning',
          'fa-info-circle': getErrorType() === 'info'
        }"></i>
        <div class="message-content">{{ errorMessage }}</div>
        <button class="close-btn" (click)="clearError()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Warning message if needed -->
      <div *ngIf="!hasAssignedTracks()" class="warning-message">
        <i class="fa fa-exclamation-triangle"></i> Please Assign Tracks First!!
      </div>

      <!-- Tabs -->
      <div class="tabs-container">
        <button class="tab" [class.active]="selectedOption === 'entireCourse'" (click)="selectedOption = 'entireCourse'; updateSelection()">
          <i class="fa fa-road"></i>
          Entire Course
        </button>
        <button class="tab" [class.active]="selectedOption === 'split'" (click)="selectedOption = 'split'; updateSelection()">
          <i class="fa fa-map-signs"></i>
          Split Course
        </button>
      </div>      <!-- Forms Container -->
      <div class="forms-container">
        <!-- Entire Course Form -->
        <div class="form-section" *ngIf="selectedOption == 'entireCourse'">
          <div class="calculation-section">
            <div class="form-group">
              <label class="form-label fw-bold mb-2">Entire Course Rail Position</label>
              <div class="flex-start gap-0">
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  [(ngModel)]="entireCourseDetails"
                  placeholder="Enter rail position"
                  required
                  (keypress)="validateNumericInput($event)"
                />
                <span class="input-group-text">m Entire Course</span>
              </div>
              <div *ngIf="getRailPositionPreview()" class="rail-preview mt-3">
                Will be stored as: {{ getRailPositionPreview() }}
              </div>
            </div>
            <div class="calculation-footer">
              <button
                type="button"
                class="btn btn-primary-soft"
                (click)="onGenerate()"
                [disabled]="isButtonDisabled"
              >
                Calculate
              </button>
            </div>
          </div>
        </div>

        <!-- Split Course Form -->
        <div class="form-section" *ngIf="selectedOption == 'split'">
          <div class="calculation-section">
            <div class="form-group">
              <label class="form-label fw-bold mb-3">Rail Position Details</label>

              <div class="rail-positions-grid">
                <!-- Rail Position -->
                <div class="form-field-container">
                  <label class="permanent-label">Rail Position</label>
                  <div class="flex-start gap-0">
                    <span class="input-group-text">+</span>
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="splitDetails1"
                      required
                      (keypress)="validateNumericInput($event)"
                    />
                    <span class="input-group-text">m</span>
                  </div>
                </div>

                <!-- Split Rail Start - Split Rail End -->
                <div class="form-field-container">
                  <label class="permanent-label">Split Rail Start - Split Rail End</label>
                  <div class="split-range-container">
                    <div class="flex-start gap-0">
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        [(ngModel)]="splitDetails2"
                        required
                        (keypress)="validateNumericInput($event)"
                      />
                      <span class="input-group-text">m</span>
                    </div>
                    <span class="range-separator">to</span>
                    <div class="flex-start gap-0">
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        [(ngModel)]="splitDetails3"
                        required
                        (keypress)="validateNumericInput($event)"
                      />
                      <span class="input-group-text">m</span>
                    </div>
                  </div>
                </div>

                <!-- Transition Length -->
                <div class="form-field-container">
                  <label class="permanent-label">Transition Length</label>
                  <div class="flex-start gap-0">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      [(ngModel)]="splitDetails5"
                      (keyup)="onSplitDetails5Change()"
                      (change)="onSplitDetails5Change()"
                      required
                      (keypress)="validateNumericInput($event)"
                    />
                    <span class="input-group-text">m</span>
                  </div>
                </div>

                <!-- Remainder -->
                <div class="form-field-container">
                  <label class="permanent-label">Remainder</label>
                  <div class="flex-start gap-0">
                    <span class="input-group-text">+</span>
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      [(ngModel)]="splitDetails4"
                      required
                      (keypress)="validateNumericInput($event)"
                    />
                    <span class="input-group-text">m</span>
                  </div>
                </div>
              </div>

              <div *ngIf="getRailPositionPreview()" class="rail-preview mt-3">
                Will be stored as: {{ getRailPositionPreview() }}
              </div>
            </div>

            <div class="calculation-footer">
              <button
                type="button"
                class="btn btn-primary-soft"
                (click)="onGenerate()"
                [disabled]="isButtonDisabled"
              >
                Calculate
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Scrollable content area -->
      <div class="scrollable-content">
        <!-- Table Results Section -->
        <div *ngIf="generating" class="races-grid">
          <div *ngFor="let tracker of tableResult; let trackerIndex = index" class="race-card">
            <div class="race-card-header">
              <h4>Race {{ trackerIndex + 1 }}</h4>
              <div class="race-meta">
                <span>TrackLength: {{ trackLengths[trackerIndex][0] }}</span>
                <span>RaceLength: {{ data.racelengths[trackerIndex] }}</span>
              </div>
            </div>
            <div class="race-card-body">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Rail Position</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Transition</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let track of tracker; let rowIndex = index">
                    <td class="col-1">
                      {{ formatRailPositionText(track.add, data.races[trackerIndex]?.TrackType) }}
                    </td>
                    <td class="col-1">
                      <input
                        type="number"
                        name="start{{ rowIndex }}"
                        [(ngModel)]="track.start"
                        class="form-control"
                        required
                        (keypress)="validateNumericInput($event)"
                      />
                    </td>
                    <td class="col-1">
                      <input
                        type="number"
                        name="end{{ rowIndex }}"
                        [(ngModel)]="track.end"
                        class="form-control"
                        required
                        (keypress)="validateNumericInput($event)"
                      />
                    </td>
                    <td class="col-1">
                      <input
                        type="number"
                        name="transition{{ rowIndex }}"
                        [(ngModel)]="track.transition"
                        class="form-control"
                        required
                        (keypress)="validateNumericInput($event)"
                      />
                    </td>
                    <td class="col-1">
                      <!-- Delete Row Button -->
                      <button
                        type="button"
                        class="btn btn-danger-soft"
                        (click)="deleteRow(trackerIndex, rowIndex)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Add Row Button -->
              <!-- <button
                type="button"
                class="btn btn-primary-soft"
                (click)="addRow(trackerIndex)"
              >
                Add Row
              </button> -->
              <br /><br />
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="screen-actions">
        <div class="flex-end">
          <button
            type="button"
            class="btn btn-success-soft"
            (click)="onSubmit()"
            [disabled]="!tableResult || tableResult.length === 0 || !generating"
          >
            Submit
          </button>
          <button type="button" class="btn btn-danger-soft" (click)="onNoClick()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
